export const AI_ASSISTANT_DRAWER_WIDTH = 500;

export const AI_ASSISTANT_UNREAD_BADGE_CAP = 99;

export const AI_ASSISTANT_DRAWER_Z_INDEX = 1_250;

export const AI_ASSISTANT_LAUNCHER_Z_INDEX = 1_260;

export const AI_ASSISTANT_GUIDELINE_FULL_VIEW_Z_INDEX = 1_270;

export const AI_ASSISTANT_LAUNCHER_LABEL = 'AI Loan Assistant';

export const AI_ASSISTANT_LAUNCHER_TOOLTIP = 'Open AI Loan Assistant';

export const AiAssistantTestId = {
  LAUNCHER: 'ai-assistant.launcher',
  LAUNCHER_BADGE: 'ai-assistant.launcher.badge',
  DRAWER: 'ai-assistant.drawer',
};
